module.exports = __webpack_public_path__ + "static/background-b2c10760ad24322b55d717e845391c37.jpg";